<template>
    <div class="columns is-centered is-mobile">
        <div class="column is-two-thirds-tablet is-four-fifths-mobile mt-6">
            <vue-simple-markdown :source="src" />
        </div>
    </div>
</template>

<script>
export default {
    name: "Privacy",
    components: {},
    data() {
        return {
            src: "",
        };
    },
    async created() {
        this.src = await fetch("/privacy.md").then((response) => {
            let markdown = response.text();
            return markdown;
        });
        console.log(this.src);
    },
};
</script>
<style lang="scss">
</style>
